// Redux Action CONSTANTS
import * as actionTypes from "./actionTypes";

// Ajax Methods
import ajaxMethods from "../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../api/ajax-endpoints";
import { appInsights } from "../../config/appInsights";
import { IInvestmentSearchParams } from "../../interfaces/investment";

export const setAdvancedInvestmentSearchParams = (
  values: IInvestmentSearchParams
) => {
  return {
    type: actionTypes.SET_ADVANCED_INVESTMENT_SEARCH_PARAMS,
    payload: values,
  };
};

export const actionStart = () => {
  return { type: actionTypes.GET_INVESTMENTS_START };
};

export const actionFailure = (error: any) => {
  return { type: actionTypes.GET_INVESTMENTS_FAILURE, error };
};

export const getInvestments = () => {
  return function (dispatch: any) {
    dispatch(actionStart());
    // ajaxMethods.post(`${ajaxEndpoints.INVESTMENTS}\\${id}`)
    ajaxMethods
      .get(ajaxEndpoints.INVESTMENTS)
      .then((response) => {
        if (response) {
          dispatch({
            type: actionTypes.GET_INVESTMENTS_SUCCESS,
            payload: response,
          });
        } else {
          dispatch(actionFailure({ message: "Newtork Failure" }));
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "investments.js",
          },
        });
        dispatch(actionFailure(error));
      });
  };
};
